import * as XLSX from "xlsx";

const COMPANY_NAME = "Swami Software PT";

export function exportToExcel(data, sheetName, fileName) {
  const ws = XLSX.utils.json_to_sheet(data);
  applyProfessionalStyle(ws);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

export function exportMultiSheet(sheets, fileName) {
  const wb = XLSX.utils.book_new();
  for (const { name, data } of sheets) {
    const ws = XLSX.utils.json_to_sheet(data);
    applyProfessionalStyle(ws);
    XLSX.utils.book_append_sheet(wb, ws, name.substring(0, 31));
  }
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

export function exportWithHeader(sheets, fileName, subtitle) {
  const wb = XLSX.utils.book_new();
  const exportDate = new Date().toLocaleDateString("en-IN", {
    day: "2-digit", month: "short", year: "numeric"
  });

  for (const { name, data } of sheets) {
    // Build header rows
    const headerRows = [
      [COMPANY_NAME],
      [subtitle || name],
      [`Exported: ${exportDate}`],
      [] // blank row separator
    ];
    const ws = XLSX.utils.aoa_to_sheet(headerRows);

    // Append data starting from row 5
    if (data.length > 0) {
      XLSX.utils.sheet_add_json(ws, data, { origin: "A5" });
    }

    applyProfessionalStyle(ws, 4); // header row is at row index 4 (0-based)
    // Merge company name across columns
    const colCount = data.length > 0 ? Object.keys(data[0]).length : 3;
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: colCount - 1 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: colCount - 1 } },
    ];

    XLSX.utils.book_append_sheet(wb, ws, name.substring(0, 31));
  }
  XLSX.writeFile(wb, `${fileName}.xlsx`);
}

function applyProfessionalStyle(ws, headerRowIdx = 0) {
  if (!ws["!ref"]) return;
  const range = XLSX.utils.decode_range(ws["!ref"]);

  // Auto column width
  const colWidths = [];
  for (let c = range.s.c; c <= range.e.c; c++) {
    let maxLen = 10;
    for (let r = range.s.r; r <= range.e.r; r++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (cell && cell.v != null) {
        const len = String(cell.v).length;
        if (len > maxLen) maxLen = Math.min(len, 40);
      }
    }
    colWidths.push({ wch: maxLen + 2 });
  }
  ws["!cols"] = colWidths;
}
